import { Country } from '@afterpay/types'
import Script from 'next/script'
import React, { FunctionComponent } from 'react'
import { useCountry } from '../../state'

declare global {
  interface Window {
    OneTrust?: {
      OnConsentChanged: (arg: any) => void
    }
    OnetrustActiveGroups?: string
  }
}

export enum CookieActiveGroup {
  Necessary = 'C0001',
  Performance = 'C0002',
  Functional = 'C0003',
  Marketing = 'C0004',
  SocialMedia = 'C0005',
}

export const OneTrust: FunctionComponent = () => {
  const country = useCountry()
  if (country === Country.GB) {
    return (
      <>
        {/*
         * This script must be placed before everything else in order to function correctly.
         * If it is not placed first it will not be able to effectively block cookies from being set.
         */}
        <Script src='https://cdn.cookielaw.org/consent/019721c5-3fd0-74bb-a995-e9d300053761/OtAutoBlock.js' />
        <Script
          src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
          data-domain-script='019721c5-3fd0-74bb-a995-e9d300053761'
          data-document-language='true'
        />
      </>
    )
  } else {
    return <></>
  }
}

export const getOnetrustCookieConsent = (country: Country, activeGroup: CookieActiveGroup): boolean => {
  if (country === Country.GB) {
    if (window?.OnetrustActiveGroups && window?.OnetrustActiveGroups?.length > 0) {
      const activeGroups = window?.OnetrustActiveGroups.split(',')
      const isOptIntoActiveGroup = activeGroups.includes(activeGroup)
      return isOptIntoActiveGroup
    }
    return false
  }

  return true
}

export const onOnetrustCookieConsentChange = (country: Country, activeGroup: CookieActiveGroup, action: any): void => {
  if (window?.OneTrust != null) {
    window.OneTrust.OnConsentChanged(() => {
      if (getOnetrustCookieConsent(country, activeGroup)) {
        action()
      }
    })
  }
}
